import React, { forwardRef } from "react";
import { ChipColorVariant } from "../types";
import { BaseChip, BaseChipProps } from "./BaseChip";

export interface ChipProps extends Omit<BaseChipProps, "color"> {
    /**
     * The standard color to pick from.
     */
    color?: ChipColorVariant;
}

export const Chip = forwardRef<HTMLDivElement, ChipProps>(({ color = "neutral", ...rest }, ref) => {
    return <BaseChip {...rest} color={color} ref={ref} />;
});

Chip.displayName = "Chip";
